import React from 'react';
import Button from '../../components/button';
import useBoolean from '../../hooks/custom-hooks/useBoolean';
import AnimationWrapper from '../../components/animation/animationWrapper';
import AwardAgreementModal from './awardAgreementModal';

/**
 * Import button + streaming modal for Award Agreement, for surfaces (e.g. all-in-one import)
 * that cannot use the legacy single-file input since this import needs Excel + ZIP streaming.
 */
function AwardAgreementImportButton(): JSX.Element {
  const { value: isModalOpen, setFalse: closeModal, setTrue: openModal } = useBoolean(false, true);

  return (
    <>
      <Button
        id='awardAgreementImport'
        variant='primary-import'
        title='Import Award Agreement'
        onClick={openModal}
      />
      <AnimationWrapper>
        {isModalOpen && <AwardAgreementModal isModalOpen={isModalOpen} closeModal={closeModal} />}
      </AnimationWrapper>
    </>
  );
}

export default AwardAgreementImportButton;
